module.exports = __webpack_public_path__ + "static/media/next.7e10275e.svg";